import { MapContainer } from "./styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { LINKS } from "../../../config/links";

const GoogleMap = ({ variant = "default" }) => {

    const mapSrc =
        LINKS.googleMapsFrame?.[variant] ||
        LINKS.googleMapsFrame?.default ||
        "";

    if (!mapSrc) return null;

    return (
        <StaggeredContainer>
            <StaggeredItem>
                <MapContainer>
                    <iframe
                        title="Location map"
                        src={mapSrc}
                        width="640"
                        height="480"
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </MapContainer>
            </StaggeredItem>
        </StaggeredContainer>
    );
};

export default GoogleMap;